<template>
  <div>
    <div v-if="isArray(internalValue)">
      <Collapse>
        <Panel>
          {{prop}}
          <Poptip
              confirm
              title="Delete this?"
              @on-ok="deleteNode()">
            <Button class="delete-button" type="ghost" shape="circle" icon="close-round" size="small"></Button>
          </Poptip>
          <p slot="content">
            <template v-for="(item, index) in internalValue">
              <json-node :prop="index.toString()" v-bind:key="index"  v-model="internalValue[index]"> </json-node>
            </template>
            <add-new-node :is-array="true" @add-new-node="add"></add-new-node>
          </p>
        </Panel>
      </Collapse>
    </div>
    <div v-else-if="isObject(internalValue)">
          <div v-if="descriptionFields.includes(prop)">
            {{addDescription(prop)}}

          </div>
      <Collapse value="0">

        <Panel >
          {{prop}}
          <Tooltip v-if="descriptionFields.includes(prop)" placement="top">
          <Button> INFO </Button>
          <div max-width="200" slot="content">
            <p>{{description}}</p>
            <p>{{description1}}</p>
            <p>{{description2}}</p>
            <p>{{description3}}</p>
            <p>{{description4}}</p>
            <p>{{description5}}</p>
            <p>{{description6}}</p>
        </div>
            </Tooltip>


          <Poptip
              confirm
              title="Delete this?"
              @on-ok="deleteNode()">
            <Button class="delete-button" type="ghost" shape="circle" icon="close-round" size="small"></Button>
          </Poptip>
          <p slot="content">
            <template v-for="(subvalue, subprop) in internalValue">
              <json-node :prop="subprop" v-bind:key="subprop" v-model="internalValue[subprop]"></json-node>
            </template>
            <add-new-node @add-new-node="add"></add-new-node>
          </p>

        </Panel>

      </Collapse>
    </div>
    <div v-else-if="isString(internalValue)">
      <Form-item :label="prop">
        <Input v-model="internalValue" :placeholder="internalValue"></Input>
        <Poptip
              confirm
              title="Delete this?"
              @on-ok="deleteNode()">
            <Button class="delete-button" type="ghost" shape="circle" icon="close-round" size="small"></Button>
          </Poptip>
      </Form-item>
    </div>
    <div v-else-if="isNumber(internalValue)">
      <Form-item :label="prop" class="switch">
        <Input-number v-model="internalValue"></Input-number>
        <Poptip
              confirm
              title="Delete this?"
              @on-ok="deleteNode()">
            <Button class="delete-button" type="ghost" shape="circle" icon="close-round" size="small"></Button>
          </Poptip>
      </Form-item>
    </div>
    <div v-else-if="isBoolean(internalValue)">
      <Form-item :label="prop" class="switch">
        <i-switch v-model="internalValue" size="large">
          <span slot="open">true</span>
          <span slot="close">false</span>
        </i-switch>
        <Poptip
              confirm
              title="Delete this?"
              @on-ok="deleteNode()">
            <Button class="delete-button" type="ghost" shape="circle" icon="close-round" size="small"></Button>
          </Poptip>
      </Form-item>
    </div>
      <div v-else-if="isNull(internalValue)">
      </div>
    <div v-else>
      <Form-item :label="prop">
        {{internalValue}}
      </Form-item>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import AddNewNode from './AddNewNode.vue';

export default {
  name: 'json-node',
  data() {
    return {
      internalValue: this.value,
      test: '',
      description: '',
      description1: '',
      description2: '',
      description3: '',
      description4: '',
      description5: '',
      description6: '',
      descriptionFields: ['relationships', 'datapoints'],
    };
  },
  props: {
    prop: [String, Number],
    value: null,
  },
  components: {
    'json-node': this,
    'add-new-node': AddNewNode,
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue;
    },
    internalValue(newValue) {
      this.$emit('input', newValue);
    },
    panelIndex() {
      console.log(`watch panelIndex id: ${this.panelIndex}`);
    // if this panelIndex matches this component's index.. do stuff since we're selected
    },
  },
  methods: {
    add(params) {
      const { name } = params;
      const { type } = params;

      const nameToNew = {
        Array: [],
        Object: {},
        String: '',
        Number: 0,
        Boolean: false,
      };

      const newItem = nameToNew[type];

      if (this.isArray(this.value)) {
        this.value.push(newItem);
      } else if (this.isObject(this.value)) {
        Vue.set(this.value, name, newItem);
      }
    },
    deleteNode() {
      this.$emit('delete-this-node');
      this.internalValue = null;
      console.log(this.internalValue);
    },
    isArray(value) {
      return Array.isArray(value);
    },
    isObject(value) {
      return (!(Array.isArray(value))
                && !(value === null)
                && (typeof value === 'object'));
    },
    isString(value) {
      return typeof value === 'string';
    },
    isNumber(value) {
      return typeof value === 'number';
    },
    isBoolean(value) {
      return typeof value === 'boolean';
    },
    isNull(value) {
      return value === null;
    },
    addDescription(value) {
      if (value === 'relationships') {
        this.description = 'Determines which file name variables are ';
        this.description1 = 'needed for a mulesoft transformation.';
        this.description2 = 'The field name refers to the mulesoft';
        this.description3 = 'transformation, and the value refers to';
        this.description4 = 'the file name variables.';
        this.description5 = '(Separate values using a comma)';
      } else if (value === 'datapoints') {
        this.description = 'Defines which file name variables are used.  ';
        this.description1 = 'Add a new object to define a new file name variable.';
        this.description2 = 'You may then add fields to this by adding a';
        this.description3 = ' new object to the variable and populating ';
        this.description4 = 'it with number variables (generally with ';
        this.description5 = 'field names of startPosition, ';
        this.description6 = 'endPosition, and index)';
      } else {
        this.description = '';
        this.description1 = '';
        this.description2 = '';
        this.description3 = '';
        this.description4 = '';
        this.description5 = '';
        this.description6 = '';
      }
    },
  },
};
</script>

<style scoped>
  .switch {
    display: inline-block;
  }

  .delete-button {
    margin: auto;
  }

  Collapse {
    margin-bottom: 10px;
  }
</style>
